'use client';

import AppImage from '../../ui/AppImage';
import { motion } from 'framer-motion';

export default function TransformingVisitsSection() {
  return (
    <section className="py-20 md:py-32 bg-background reveal">
      <div className="container mx-auto px-6">
        {/* Header */}
        <div className="max-w-3xl mb-16">
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-4xl md:text-5xl lg:text-6xl font-bold text-foreground mb-6 leading-tight">

            Your Natural
            <br />
            Hair is Enough
            <br />
            Embrace it!
          </motion.h2>
        </div>

        {/* Bento Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {/* Large Image Card */}
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="lg:row-span-2 rounded-3xl overflow-hidden group cursor-pointer">

            <div className="relative h-full min-h-[400px]">
              <AppImage
                src="/resource/natural_hair_twist.jpg"
                alt="Natural Hair Twists"
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" />

              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
              <div className="absolute bottom-6 left-6 right-6">
                <h3 className="text-2xl font-bold text-white">
                  Natural Hair Twists
                </h3>
              </div>
            </div>
          </motion.div>

          {/* Stats Card */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="bg-primary rounded-3xl p-8 flex flex-col items-center justify-center text-center group hover:shadow-2xl transition-shadow duration-300">

            <div className="mb-4">
              <span className="text-6xl md:text-7xl font-bold text-primary-foreground">
                1000+
              </span>
            </div>
            <p className="text-lg font-medium text-primary-foreground/90">
              Happy Clients
            </p>
            <p className="text-sm text-primary-foreground/70 mt-2">
              Styled with care
            </p>
          </motion.div>

          {/* Image Card 2 */}
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="rounded-3xl overflow-hidden group cursor-pointer">

            <div className="relative h-full min-h-[280px]">
              <AppImage
                src="/resource/mini_twist.jpg"
                alt="Mini Twist"
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" />

              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
              <div className="absolute bottom-6 left-6 right-6">
                <h3 className="text-xl font-bold text-white">
                  Mini Twist
                </h3>
              </div>
            </div>
          </motion.div>

          {/* Text Card */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.3 }}
            className="bg-card border border-border rounded-3xl p-8 flex flex-col justify-center">

            <p className="text-base text-muted-foreground leading-relaxed">
              MEVOLY Hair & Care Natural Hair Wellness Salon is your most trusted salon. Our goal is to help you love your hair while growing it healthier and longer. We offer personalized, premium hair care and styling services to bring you closer to your hair goals.
            </p>
          </motion.div>
        </div>
      </div>
    </section>);



}